import { ApiLink } from "../../../APILink/ApiLink";
import { errorAlert } from "../../../Components/Alerts";
import axios from "axios";
import authHeader from "../../../Auth/authHeader";
import { useContext, useEffect, useState } from "react";
import { FiscalYearContext } from "../../../FiscalYear/FiscalYearContext";
import '../../../Style/Kartela.scss';
import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Legend,
    LabelList
} from "recharts";
import { ElementsParagraph, TitleElements } from "../../../Components/HeadersCRUD-s";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from '@mui/material/TextField';
import DataGridComponent from "../../../Components/DataGridComponent";
import { FinancialHeader, MaterialSintetikHeaders, MaterialAnalitikHeaders } from "../GridHeaders/FinancialHeader";
import DataGridShowDetails from "../../../Components/DataGridShowDetails";
import { AddActionsButton } from "../../../Components/AddElementsButton";
import { AiOutlineClose } from "react-icons/ai";

const COLORS = ["green", "blue", "purple"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
    index
}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text
            x={x}
            y={y}
            fill="white"
            textAnchor={x > cx ? "start" : "end"}
            dominantBaseline="central"
        >
            {value}
        </text>
    );
};

export default function AgentDetails(props) {
    const { accountID, accName } = props;

    const [agent, setAgent] = useState([]);
    const [agentID, setAgentID] = useState(0);

    const [accountName, setAccountName] = useState("")
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const [showOtherTable, setShowOtherTable] = useState(false);
    const [debiKrediData, setDebiKrediData] = useState([]);
    const [analiticFinancial, setAnalitikFinancial] = useState([]);
    const [materialSintetikData, setMaterialSintetikData] = useState([]);
    const [materialAnalitikData, setMaterialAnalitikData] = useState([]);
    const [pieChartData, setPieChartData] = useState([]);

    const [showDatesField, setShowDatesField] = useState(false);

    const [ngaData, setNgaData] = useState(`${fiscalYear}-01-31`);
    const [deriData, setDeriData] = useState(`${fiscalYear}-12-31`);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const fetchCreditDebitAccount = async (user) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/getDebitAndCreditForAgents', {
                headers,
                params: { year: fiscalYear, user: user }
            });
            setShowOtherTable(false);
            setDebiKrediData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const fetchKartelaAnalitike = async (user, nga, deri, year) => {
        if (nga > deri) {
            errorAlert("Data Deri duhet te jete me i madh ose e ngjajshme me daten Nga")
        }
        else {
            try {
                const response = await axios.get(ApiLink.API_URL + 'Card/getKartelaFinanciareAnalitikeForAgent', {
                    headers,
                    params: { user: user, fromDate: nga, toDate: deri, fiscalYear: year }
                });
                setAnalitikFinancial(response.data);
                setShowOtherTable(false);

                // console.log(response.data);
            } catch (error) {
                errorAlert("Gabim në kërkesë:", error);
                if (error.response?.data?.errorMessage) {
                    errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
                } else if (error.message) {
                    errorAlert(`Gabim: ${error.message}`);
                } else {
                    errorAlert("Gabim i panjohur në kërkesë.");
                }
            }
        }
    };

    const fetchMaterialSintetikData = async (user, nga, deri, year) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/getKartelaMaterialeSintetikeForAgent', {
                headers,
                params: { user: user, fromDate: nga, toDate: deri, fiscalYear: year }
            });
            setMaterialSintetikData(response.data);
            setShowOtherTable(false);
            // console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const fetchMaterialAnalitikData = async (fiscalYear, accountID, articleID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/getKartelaMaterialeAnalitikeForAgent', {
                headers,
                params: { user: accountName, articleID: articleID, fromDate: ngaData, toDate: deriData, fiscalYear: fiscalYear }
            });
            setShowOtherTable(true);
            setMaterialAnalitikData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const fetchPieChartData = async (user) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/pieChartBalanceForAgent', {
                headers,
                params: {
                    fiscalYear: fiscalYear, // Ky duhet të përputhet me backend
                    user: user   // Dhe ky gjithashtu
                }
            });
            setShowOtherTable(false);
            setPieChartData(response.data);
            console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Users/getusers', { headers });
            setAgent(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const [accField, setAccfield] = useState(null)
    const [userName, setUserName] = useState(null)

    const handleAutocompleteChangeAgent = (event, value) => {
        if (value && value.Id) {
            setAgentID(value.Id);
            setAccfield(value);
            setUserName(value.UserName);
            fetchKartelaAnalitike(value.UserName, `${fiscalYear}-01-31`, `${fiscalYear}-12-31`, fiscalYear);
            fetchMaterialSintetikData(value.UserName, `${fiscalYear}-01-31`, `${fiscalYear}-12-31`, fiscalYear);
            fetchCreditDebitAccount(value.UserName);
            fetchPieChartData(value.UserName);
            setShowOtherTable(false);

        } else {
            // Në rast se vlera është pastruar
            setAgentID(""); // Vendos vlerën e ArticleID në null
            setNgaData(`${fiscalYear}-01-31`);
            setDeriData(`${fiscalYear}-12-31`);
        }
    };

    const defaultPropsAgent = {
        options: agent,
        getOptionLabel: (option) =>
            option.UserName || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {/* {option.Id}<br /> */}
                        {option.UserName}
                    </span>
                </li>
            </>
        ),
    };

    const rows = analiticFinancial.map((item, index) => ({
        id: index + 1,
        actionType: item.ActionType,
        accName: item.AccountName,
        idNumber: item.IdentificationNumber,
        comment: item.Comment,
        date: item.Date,
        debit: item.Debit,
        credit: item.Credit,
        progressive: item.Progressive,
    }));


    const materialSintetikRows = materialSintetikData.map((item, index) => ({
        id: ++index,
        // accID: item.AccountID,
        Barcode: item.Barcode,
        ArticleName: item.ArticleName,
        totalTransaction: item.TotalTransactions,
        TotalQtyOutput: item.TotalQtyOutput,
        AvgPriceWithoutVAT: item.AvgPriceWithVAT,
        TotalAmount: item.TotalAmount,
        showDetails: item.AccountID,
        articleIDForShow: item.ArticleID,
        rowInfo: item
    }));

    const materialAnalitikRows = materialAnalitikData.map((item, index) => ({
        id: ++index,
        ActionType: item.ActionType,
        Barcode: item.Barcode,
        ArticleName: item.ArticleName,
        date: item.Date,
        QtyOutput: item.QtyOutput,
        PriceWithVAT: item.PriceWithVAT,
        TotalAmount: item.Total,
        showDetails: item.AccountID,
        rowInfo: item
    }));

    const showFields = () => {
        setShowDatesField(true);
        setNgaData("");
        setDeriData("");
        setAnalitikFinancial([]);
    }

    const showAnnualData = () => {
        setShowDatesField(false);
        setNgaData(`${fiscalYear}-01-31`);
        setDeriData(`${fiscalYear}-12-31`);
    }

    useEffect(() => {
        if (ngaData && ngaData !== "" && deriData && deriData !== "") {
            fetchKartelaAnalitike(accName, ngaData, deriData, fiscalYear);
            fetchMaterialSintetikData(accName, ngaData, deriData, fiscalYear);

        }
    }, [ngaData, deriData]);

    useEffect(() => {
        if (accName) {
            setAccountName(accName);
        }
    }, [accName]);

    useEffect(() => {
        if (accName) {
            fetchCreditDebitAccount(accName);
            // fetchKartelaAnalitike(accountName);
            // fetchMaterialSintetikData(accountName);
            fetchPieChartData(accName);
        }
    }, [accountName, fiscalYear]);

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <div className="Card_AccountDetails__Container">
            <div>
                <TitleElements
                    // icon={SiHyperledger}
                    title={`Kartela financiare e klientit: ${accountName}`}
                />

                <ElementsParagraph text="Kartela e klientit shfaq informacionet kryesore dhe është e përshtatur për shtypje." />
            </div>

            <div className="Card_AccountDetails__Container__SelectList">
                <Autocomplete
                    // style={{ width: "30%" }}
                    className="Card_AccountDetails__Container__SelectList__AutoComplete"
                    {...defaultPropsAgent}
                    id="include-input-in-list"
                    includeInputInList
                    onChange={handleAutocompleteChangeAgent}
                    isOptionEqualToValue={(option, value) => option.Id === value.Id} // Shto funksionin isOptionEqualToValue
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            // style={{ width: "55% " }}
                            // className="Card_AccountDetails__Container__SelectList__TextField"
                            label="Kerko Agjentin"
                        />
                    )}
                />
            </div>

            <hr></hr>
            <div className="AccountDetails__Container__BarChart" >
                <div className="AccountDetails__Container__BarChart__one">
                    <ResponsiveContainer width="100%" height={400} >
                        <BarChart className="AccountDetails__Container__BarChart__one__chart__Inside"
                            // width={1200}
                            // height={400}
                            data={debiKrediData}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="MonthNumber" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Te Pagueshme" fill="green" minPointSize={0}>
                                <br></br>
                                {/* <LabelList dataKey="MonthNumber" /> */}
                            </Bar>
                            <Bar dataKey="Pagesat" fill="blue" minPointSize={0} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                <div className="AccountDetails__Container__BarChart__two">
                    <ResponsiveContainer width="100%" height={400}>
                        <PieChart >
                            <Legend />
                            <Pie
                                data={pieChartData}
                                // cx={200}
                                // cy={200}
                                labelLine={false}
                                label={renderCustomizedLabel}
                                outerRadius={140}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {pieChartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer >
                </div >
            </div >
            <br></br>
            <div className="Inventory__Container__Header__Bottom__Left">
                {
                    showDatesField ?
                        <div>
                            <AddActionsButton
                                text="Shfaq kartelen vjetore"
                                onClick={showAnnualData}
                                // icon={<AiOutlineFilePdf />}
                                className="button-15"
                            />
                            <TextField
                                className="AccountingBooks__Container__SearchSection__Search__Input__Month"
                                id="date"
                                type="date"
                                variant="outlined"
                                name='Date'
                                label="Nga"
                                value={ngaData}
                                onChange={(e) => { setNgaData(e.target.value); }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    min: minDate,
                                    max: maxDate,
                                }}
                            />
                            <TextField
                                className="AccountingBooks__Container__SearchSection__Search__Input__Month"
                                id="date"
                                type="date"
                                variant="outlined"
                                name='Date'
                                label="Deri"
                                value={deriData}
                                onChange={(e) => { setDeriData(e.target.value); }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    min: minDate,
                                    max: maxDate,
                                }}
                            />
                        </div>
                        :
                        <AddActionsButton
                            text="Shfaq kartelat sipas datave"
                            onClick={showFields}
                            // icon={<AiOutlineFilePdf />}
                            className="button-15"
                        />
                }

            </div>
            <ElementsParagraph text="Kartela Financiare Analitike" />
            <DataGridComponent columns={FinancialHeader} rows={rows} />
            <br></br>
            <ElementsParagraph text="Kartela Materiale Sitentike" />
            <DataGridShowDetails
                columns={MaterialSintetikHeaders}
                rows={materialSintetikRows}
                fetchAccountsDetails={fetchMaterialAnalitikData}
                height={500}
            />
            <br></br>
            {
                showOtherTable ?
                    <>
                        <div className="Card_AccountDetails__Container__ResButton">
                            <ElementsParagraph text="Kartela Materiale Analitike" />

                            <AddActionsButton
                                text="Mbyll"
                                onClick={() => setShowOtherTable(false)}
                                icon={<AiOutlineClose />}
                                className="button-15"
                            />
                        </div>
                        <DataGridComponent columns={MaterialAnalitikHeaders} rows={materialAnalitikRows} />

                    </>
                    :
                    <></>
            }
            <br></br>
        </div >
    )
}

